import React from 'react'
import { MStockLoadingUI } from '@components/organism/mStock/MStockLoadingUI.jsx'

export const Loading = () => {
  return (
    <div
      data-testid="loader"
      className="bg-m-surface-page fixed top-0 left-0 z-1300 h-screen w-full"
    >
      <MStockLoadingUI
        className="absolute top-1/2 left-1/2 -translate-x-1/2"
        aria-label="Miraeasset Loading"
      />
    </div>
  )
}
